var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHangup = function SvgHangup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.4c-4.7 2.1-5.9 4-3.6 6 1.6 1.5 2.2 1.5 4 .4 1.2-.7 2.1-2.1 2.1-3C8 9.4 8.8 9 12 9s4 .4 4 1.8c0 .9.9 2.3 2.1 3 1.8 1.1 2.4 1.1 4-.4 2.7-2.5 2.4-3.3-2.3-5.4-5-2.3-10-2.5-14.3-.6z"
  })));
};
export default SvgHangup;